import * as ko from 'knockout';

export interface LinkRegistrationModel {
    Email: string;
    Password: string;
    ConfirmPassword: string;
}

export class LinkRegistrationModelKo {
    Email: KnockoutObservable<string>;
    Password: KnockoutObservable<string>;
    ConfirmPassword: KnockoutObservable<string>;

    constructor() {
        this.Email = ko.observable(null);
        this.Password = ko.observable(null);
        this.ConfirmPassword = ko.observable(null);
    }
}